import * as React from "react";

import { Nullable } from "@core/utils";

export type Content<T = string> = Nullable<T>;
export type ContentSetter = React.Dispatch<React.SetStateAction<Content>>;
export type GetContentSetter = (contentSetter: ContentSetter) => void;
export type AfterFieldContentProps = React.PropsWithChildren<{ getContentSetter: GetContentSetter }>;

export const AfterFieldContent: React.FC<AfterFieldContentProps> = (props) => {
  const [content, setContent] = React.useState<Content>(undefined);
  React.useEffect(() => props.getContentSetter(setContent), []);

  return React.cloneElement(props.children as React.ReactElement, { content });
};

export type AfterFieldContentChildProps<T = string> = React.PropsWithChildren<{ content?: Content<T> }>;
export type AfterFieldContentChild<T = string> = React.FC<AfterFieldContentChildProps<T>>;
